import type { Step } from "react-joyride";

export const documentAuditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າປະຫວັດການກວດສອບເອກະສານ. ຕິດຕາມຍ້ອນຫຼັງການດຳເນີນງານທັງໝົດຂອງເອກະສານການເງິນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="document-audit-header"]',
    content:
      "ຫົວຂໍ້ຫນ້າ. ກອງຕາມປະເພດເອກະສານ, ວັນທີ ຫຼື ຄົ້ນຫາເລກທີ / ລູກຄ້າ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="document-audit-timeline"]',
    content:
      "ກິດຈະກຳຫຼ້າສຸດ: ສະແດງປະຫວັດການດຳເນີນງານລ່າສຸດຂອງເອກະສານ.",
    placement: "right",
  },
  {
    target: '[data-tourid="document-audit-table"]',
    content:
      "ຕາຕະລາງປະຫວັດການກວດສອບ. ກົດເພື່ອເບິ່ງລາຍລະອຽດເອກະສານທີ່ກ່ຽວຂ້ອງ.",
    placement: "top",
  },
  {
    target: '[data-tourid="document-audit-summary"]',
    content:
      "ສະຫຼຸບ: ຈຳນວນລາຍການ 24 ຊົ່ວໂມງຫຼ້າສຸດ, ເອກະສານທັງໝົດ ແລະ ສະຖານະລະບົບ.",
    placement: "top",
  },
];
